import { api_GET } from "services/api_service.js";
import { showMessage } from "services/message";

const ValidaEmail = (email, callback) => {
    api_GET('email/ValidaEmail/' + email)
        .then(result => { callback(result, email) })
        .catch(err => showMessage("Aviso", err.message, 'error', null))
}

export {
    ValidaEmail
}